import { useQuery } from '@tanstack/react-query';

// ---------------------------------------------------------------------------
// Helper: extract YouTube Video ID from various URL formats
// ---------------------------------------------------------------------------
function extractVideoId(url) {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/\s]{11})/,
    /youtube\.com\/shorts\/([^&?/\s]{11})/,
  ];
  for (const re of patterns) {
    const m = url.match(re);
    if (m) return m[1];
  }
  return null;
}

// ---------------------------------------------------------------------------
// Parse Google Sheets gviz/tq JSON response
// ---------------------------------------------------------------------------
function parseGvizResponse(rawText) {
  const jsonStart = rawText.indexOf('{');
  const jsonEnd = rawText.lastIndexOf('}');
  if (jsonStart === -1 || jsonEnd === -1) throw new Error('Invalid gviz response');
  const json = JSON.parse(rawText.slice(jsonStart, jsonEnd + 1));

  const rows = json.table.rows || [];

  return rows
    .map((row, idx) => {
      // ดึงข้อมูลตาม index ของคอลัมน์ A=0
      const getVal = (i) => (row.c && row.c[i] ? (row.c[i].v ?? row.c[i].f ?? '') : '');

      const youtubeUrl = getVal(0);
      const videoId = extractVideoId(youtubeUrl);

      return {
        id: `gs-${idx}`,
        title: 'Meya Video',
        youtube_url: youtubeUrl,
        description: '',
        publish_date: '',
        video_id: videoId,
        thumbnail: videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '',
      };
    })
    .filter((v) => v.video_id);
}

const SHEET_ID = process.env.REACT_APP_MEDIA_SHEET_ID || '';

export function useMediaVideos() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['media-videos', SHEET_ID],
    queryFn: async () => {
      if (!SHEET_ID) return [];

      const url = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json&sheet=Sheet1&headers=1&tq=select%20A`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const text = await res.text();
      return parseGvizResponse(text);
    },
  });

  return {
    videos: data ?? [],
    loading: isLoading,
    error: error?.message ?? null,
  };
}
